import React from 'react';
import styles from './scss/automatedMints.module.scss';

type enableProps = {
  children: any;
  searchWords:any;
}

export const Highlights = ({children,searchWords}:enableProps) =>{

  var childrenRes = children.toLowerCase();
  var parts = childrenRes;

  const regexp = new RegExp(`${searchWords.join('|').toLowerCase()}`, 'g');
  const matches = childrenRes.match(regexp);
  parts = childrenRes.split(new RegExp(`${searchWords.join('|').toLowerCase()}`, 'g'));
  
  for (var i = 0; i < parts.length; i++) {
    if (i !== parts.length - 1) {
      let match = matches[i];
      while(parts[i + 1] === '') {
        match += matches[++i];
      }
      
      parts[i] = (
        <React.Fragment key={i}>
          {parts[i]}<span style={{background:"#FFFF00"}} className={
            styles.tranText }>
            { match}
          </span>
        </React.Fragment>
      );
    }
   
  }


  
  return (   <>
    <div><p><ul><li> {parts} </li> </ul></p></div>
    
  </>);
};